import React from 'react'
import { Button } from '..'
import propTypes from 'prop-types';

import { CloseRoundedIcon } from '../../../theme/icons'

export const LogoutConfrimation = ({ content, loader }) => {
    const { handleYes, title, description, yesButtonLabel, noButtonLabel, loaderYestext, onCloseDialog } = content;

    return (
        <>
            <div className="border-secondary-400">
                <div className="p-15 bg-white/44 backdrop-blur-sm rounded-t-lg">
                    <div className="flex justify-between items-center">
                        <h2 className="text-secondary-500 font-semibold text-md">{title}  </h2>
                        <Button text="" className="p-0" onClick={onCloseDialog} variant="tertiary" icon={<CloseRoundedIcon />} />
                    </div>
                </div>
                <div className="p-15 bg-white rounded-b-lg">
                    <div className="text-xs mb-2 text-secondary-400">
                        {description}
                    </div>

                    <div className="pt-3 flex flex-row justify-end">
                        <Button variant="secondary" disabled={loader} type="button"
                            onClick={onCloseDialog} text={noButtonLabel} className={"mr-15"} />
                        <Button variant="primary" loader={loader} loaderText={loaderYestext} disabled={loader} type="button" onClick={handleYes}
                            text={yesButtonLabel} />
                    </div>
                </div>
            </div>
        </>

    )
}

LogoutConfrimation.propTypes = {
    content: propTypes.shape({
        loader: propTypes.bool,
        children: propTypes.node,
        title: propTypes.string,
        description: propTypes.string,
        yesButtonLabel: propTypes.string,
        noButtonLabel: propTypes.string,
        loaderYestext: propTypes.string,
        onCloseDialog: propTypes.func,
    }),
    loader: propTypes.bool
}


LogoutConfrimation.defaultProps = {
    content: {
        loader: false,
        children: <></>,
        title: '',
        description: '',
        yesButtonLabel: '',
        noButtonLabel: '',
        loaderYestext: '',
        onCloseDialog: () => null
    },
    loader: propTypes.bool
}